// Pull the join code out of whatever somebody pasted.
//
// People paste the whole message, the whole URL, or just the code, and all
// three are obviously "the link" to them. Anything with a /join/ in it hands
// back the part after it; anything else is treated as the code itself.

export function tokenFromPastedLink(raw: string): string | null {
  const text = (raw ?? "").trim();
  if (!text) return null;

  // The link may be sitting in the middle of a pasted sentence.
  const inText = text.match(/\/join\/([^\s?#/]+)/);
  if (inText) return inText[1];

  // No /join/ at all: the code on its own, as long as it looks like one and is
  // not a stray sentence.
  const bare = text.split(/\s+/).pop() ?? "";
  return /^[A-Za-z0-9._-]{6,}$/.test(bare) ? bare : null;
}
